import { Box, Text, Flex } from '@chakra-ui/react';
import { StatusConfig } from './Commercial.helpers';

export const TurbineStatus = ({ status, value, ...rest }) => {
    const config = StatusConfig[status] || {};
    return (
        <Flex width="100%" alignItems="center" {...rest} data-testid={`turbine-status-${status}`}>
            <Box bg={config.borderColor} w="4px" h="21px" mr={3} />
            <Text color="gray2" fontSize="sm" mr={3}>
                {config.name}
            </Text>
            <Box flex="1" />
            <Text fontSize="md" fontWeight="bold" data-testid="turbine-status-value">
                {value}
            </Text>
        </Flex>
    );
};
